import { buildSvgPath } from "@/scripts/common/svg-path";
import { animate, inView, stagger } from "motion";
import { CountUp } from "countup.js";

const runCounter = (el) => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return;
  }

  const useGrouping = el.dataset.useGrouping;
  const decimalPlaces = el.dataset.decimalPlaces;
  const end = el.dataset.end;

  const opts = {
    useGrouping: !!+useGrouping,
  };

  if (decimalPlaces) {
    opts.decimalPlaces = decimalPlaces;
  }

  const counter = new CountUp(el, end, opts);

  counter.start();
};

document.querySelectorAll(".element-stats").forEach((el) => {
  const nextEl = el.nextElementSibling;

  inView(
    el,
    () => {
      const items = el.querySelectorAll(".stats-item");
      const els = el.querySelectorAll("[data-counter]");

      if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        els.forEach((counter) => runCounter(counter));
      }

      animate(
        items,
        { opacity: 1, translate: "0px 0px" },
        {
          duration: 0.8,
          delay: stagger(0.2),
        },
      );
    },
    {
      margin: "0px 0px -25% 0px",
    },
  );

  if (nextEl.classList.contains("element-icongridcallouts")) {
    const pathContainer = document.body;

    const getLeftX = () => {
      const containerPadding = Math.min(75, (5.5 / 100) * window.innerWidth);
      const maxWidth = 1440;

      if (window.innerWidth < maxWidth + containerPadding) {
        return containerPadding / 2;
      }

      return (window.innerWidth - maxWidth) / 2;
    };

    const getPathPoints = () => {
      const firstStat = pathContainer.querySelector(".stats-item .stats-value");
      const firstStatRect = firstStat.getBoundingClientRect();
      const nextElTitle = nextEl.querySelector(".element-title");
      const nextElTitleRect = nextElTitle.getBoundingClientRect();

      const points = [];

      if (!window.matchMedia("(min-width: 768px)").matches) {
        return points;
      }

      const leftX = getLeftX();
      const offset = window.matchMedia("(max-width: 1279px)").matches ? 24 : 48;

      points.push({ x: firstStatRect.x - offset, y: firstStatRect.y + firstStatRect.height / 2.5 });
      points.push({ x: leftX, y: firstStatRect.y + firstStatRect.height / 2.5 });
      points.push({ x: leftX, y: nextElTitleRect.y + nextElTitleRect.height / 2 });
      points.push({
        x: nextElTitleRect.x - offset,
        y: nextElTitleRect.y + nextElTitleRect.height / 2,
      });

      return points;
    };

    const handleSvgPath = () => {
      const pathPoints = getPathPoints();
      const cornerRadius = window.matchMedia("(max-width: 1279px)").matches ? 40 : 70;

      buildSvgPath(pathContainer, pathPoints, { gradientId: "page-line-gradient-faded", cornerRadius });
    };

    const resizeObserver = new ResizeObserver(() => requestAnimationFrame(handleSvgPath));
    resizeObserver.observe(document.body);
  }
});
